import { ComponentProps } from 'react';
import { FormEngineButtonElementBasePopover } from './base-popover';
import FormEngine from '@form-engine/core-application/index';

export default function FormEngineButtonElementNetworkRequiredPopover({
    children,
    ...props
}: ComponentProps<typeof FormEngineButtonElementBasePopover>) {
    return (
        <FormEngineButtonElementBasePopover {...props}>
            {FormEngine.i18n.c('button-element.network-required')}
            {children}
        </FormEngineButtonElementBasePopover>
    );
}
